export const characterConverter = {
  fromFirestore: (snapshot, options) => {
    const character = snapshot.data(options);
    const id = snapshot.id;

    return {
      _id: id,
      avatar: character.avatar_url,
      color: character.color,
      name: character.name || "",
    };
  },
  toFirestore: (character) => {
    delete character._id;
    return {
      ...character,
    };
  },
};
